import _omit from "ramda/src/omit";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _lensProp from "ramda/src/lensProp";
import _over from "ramda/src/over";
import _pipe from "ramda/src/pipe";
import _applyTo from "ramda/src/applyTo";
import _toUpper from "ramda/src/toUpper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _curry from "ramda/src/curry";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import fetch, { RESPONSE } from "../../browser/fetch";
import { getFirstError, gqlReqToHttpReq, throwFirstError } from "./lib";
export { getFirstError, throwFirstError };
export { ConnectionIterator } from "./ConnectionIterator";
export var queryHttp = _curry(function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var url, defaultToken, _ref$headers, defaultHeaders, defaultCached, defaultMethod, fetchOverride, query, variables, operationName, _ref2$headers, headers, _ref2$method, method, _ref2$auth, auth, _ref2$cached, cached;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, defaultToken = _ref.auth, _ref$headers = _ref.headers, defaultHeaders = _ref$headers === void 0 ? {} : _ref$headers, defaultCached = _ref.cached, defaultMethod = _ref.method, fetchOverride = _ref.fetch;
          query = _ref2.query, variables = _ref2.variables, operationName = _ref2.operationName, _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers, _ref2$method = _ref2.method, method = _ref2$method === void 0 ? defaultMethod : _ref2$method, _ref2$auth = _ref2.auth, auth = _ref2$auth === void 0 ? defaultToken : _ref2$auth, _ref2$cached = _ref2.cached, cached = _ref2$cached === void 0 ? defaultCached : _ref2$cached;
          if (auth) console.warn('[queryHttp] DeprecationWarning: opts.auth deprecated for opts.headers.authorization');
          if (!method && cached) method = 'GET';
          if (!method) method = 'POST';
          if (!(cached && _toUpper(method) === 'POST')) {
            _context.next = 7;
            break;
          }
          throw Error('Cannot get cached GraphQL queries over POST');
        case 7:
          return _context.abrupt("return", _applyTo({
            method: method,
            query: query,
            variables: variables,
            operationName: operationName,
            headers: headers
          }, _pipe(_over(_lensProp('headers'), function (headers) {
            return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultHeaders), headers), auth ? {
              authorization: "Bearer ".concat(auth)
            } : {}), cached ? {} : {
              'cache-control': 'max-age=0'
            });
          }), gqlReqToHttpReq, _omit(['context']), function (opts) {
            return fetch(url, _objectSpread({
              respondWith: RESPONSE.FULL,
              fetch: fetchOverride
            }, opts)).then(function (res) {
              return _objectSpread(_objectSpread({}, res.body), {}, {
                headers: res.headers
              });
            });
          })));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());